import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';

const AvatarChip = (props: { personName: string }) => {
  const { personName } = props;
  if (!personName || personName === ' ') {
    return <div></div>;
  }

  return (
    <Chip
      avatar={<Avatar>{personName[0]}</Avatar>}
      size="small"
      label={personName}
    />
  );
};

export default AvatarChip;
